import gsap from 'gsap'
import { useEffect, useState, useRef} from 'react';
import { useGlobalContext } from './context';

const Game = () => {
    const { images, amount } = useGlobalContext();
    var rowCount, cardHeight, cardWidth;
    var pairCount = 0;
    const [completedTime, setCompletedTime] = useState(0);
    var pair = [];
    var myClock = null;
    const [win, setWin] = useState(false);
    const inputEl = useRef(null)
    const delay = ms => new Promise(res => setTimeout(res, ms));
    gsap.utils.shuffle(images);

    //Calculate card placements
    if (amount === 5) {
        rowCount = 5;
        cardWidth = Math.floor(window.screen.availWidth / 7) + 'px';
        cardHeight = Math.floor(window.screen.availHeight / 3) + 'px';
    } else if (amount === 12) {
        rowCount = 8;
        cardWidth = Math.floor(window.screen.availWidth / 10) + 'px';
        cardHeight = Math.floor(window.screen.availHeight / 4) + 'px';
    } else if (amount === 16) {
        rowCount = 8;
        cardWidth = Math.floor(window.screen.availWidth / 10) + 'px';
        cardHeight = Math.floor(window.screen.availHeight / 5.3) + 'px';
    } else if (amount === 20) {
        rowCount = 10;
        cardWidth = Math.floor(window.screen.availWidth / 12) + 'px';
        cardHeight = Math.floor(window.screen.availHeight / 5.5) + 'px';
    }
   
    useEffect(() => {
        document.querySelectorAll('.cardCont').forEach(el => {
            gsap.set(el.firstChild, { rotationY: -180 });
            gsap.set(el, { perspective: 1000, transformStyle: "preserve-3d" });
            // eslint-disable-next-line
            var tl = gsap.timeline({ paused: true, onReverseComplete: () => { pair = []; } });
            tl.to(el.lastChild, { rotationY: 180, duration: 1 });
            tl.to(el.firstChild, { rotationY: 0, duration: 1 }, 0);
            tl.to(el, { z: 50, duration: .5 }, 0);
            tl.to(el, { z: 0, duration: .5 }, .5);
            el.animation = tl;
        });
        // eslint-disable-next-line
        myClock = setInterval(clock, 1000);
        document.querySelector('audio').play();
       
    }, []);

    const clock = () => {inputEl.current.innerHTML = parseInt(inputEl.current.innerHTML) + 1}
    
    const finishGame = async () => {
        await clearInterval(myClock);
        setCompletedTime(inputEl.current.innerHTML);
        setWin(true);
    }

    const flipCard = async (e) => {
        pair.push(e.target.parentElement);
        if (pair.length === 2)
            document.querySelectorAll('.cardCont').forEach(el => el.style.pointerEvents = "none");
        await e.target.parentElement.animation.play();
        if (pair.length === 2) {
            if (pair[0].id === pair[1].id) {
                pair = [];
                pairCount += 1;
                if (pairCount === amount) 
                    finishGame();      
            }  
            else {
                await delay(1000);
                pair[0].animation.reverse();
                pair[1].animation.reverse();
            }
            setTimeout(function () { document.querySelectorAll('.cardCont').forEach(el => el.style.pointerEvents = "auto"); }, 1000);
        }
    }
    
    const audioControls = () => {
        if (document.querySelector('audio').paused) {
            document.querySelector('audio').play()
            document.querySelector('.sound').className = "sound fas fa-volume-up fa-2x  p-2"
        } else {
            document.querySelector('audio').pause();
            document.querySelector('.sound').className = "sound fas fa-volume-mute fa-2x  p-2"
        }
    }
    

    if (win)
        return (
            <div className='container mt-5 ml-auto border rounded p-2 text-center bg-light'>
                <h2>You've completed the game in { completedTime } seconds.</h2>
                <button className='btn btn-dark ml-4 w-25' onClick={() => { window.location.reload() }}> <h5 className='mt-2'>Home</h5> </button>
            </div>
        )
    else
        return (
            <div style={{ position: 'absolute', top: '0', left: '0', backgroundImage: 'linear-gradient(to top, #fbc2eb 0%, #a6c1ee 100%)'}} className='w-100 h-100' >
                <div className='hud d-flex align-items-center'>
                    <i  onClick={() => audioControls()} className = "sound fas fa-volume-up fa-2x  p-2"></i>
                    <i onClick={() => { window.location.reload() }} className="fas fa-home fa-2x  p-2"></i>
                    <h2  className='m-2'>Time:<span ref={inputEl}>0</span></h2>
                    <audio src="https://www.bensound.com/bensound-music/bensound-moose.mp3"></audio>
                </div>
                <div style={{gridTemplateColumns:`repeat(${rowCount}, 1fr)`}} className='game-cards-container'>
                    {
                    images.map(image => {
                        return (
                        <div style={{ width: `${cardWidth}`, height:`${cardHeight}`, cursor:'pointer'}} key={Math.random()} id={image} className="cardCont">
                            <div style={{ backgroundImage: `url(${image})`}} className="card cardBack"></div>
                            <div onClick={(e) => flipCard(e)}  className="card cardFront"></div>
                        </div>  
                        )  
                    })
                    }
                </div>
                
            </div>
            
        )
}

export default Game;